import { render } from "./LeftSection.vue?vue&type=template&id=64586774&scoped=true"
import script from "./LeftSection.vue?vue&type=script&lang=js"
export * from "./LeftSection.vue?vue&type=script&lang=js"

import "./LeftSection.vue?vue&type=style&index=0&id=64586774&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64586774"]])

export default __exports__